import * as React from 'react';
import { t } from '@citrite/translate';
import { SearchIcon, withModals, WithModalsProps } from '@citrite/web-ui-component';
import { trackAnalyticsEvent } from 'analytics';
import { RouteComponentProps, useRouteMatch, withRouter } from 'react-router-dom';
import { useFormFactor } from 'App/Header/useFormFactor';
import {
	StyledDaasSearchBarDiv,
	StyledDaasSearchTextSpan,
	StyledSearchIconContainer,
	StyledSearchTextContainer,
} from 'App/Masthead/ItemSearchBar.styled';
import { SearchModule } from 'App/Masthead/SearchModule';
import { isSimpleView } from 'App/Navigation/utils';
import { searchRoute } from 'App/Search';
import { MobileSearchModal } from 'App/Search/MobileSearchModal';
import { useLoadableResourceContext } from 'Workspace/ResourceProvider';
import { searchCASReporter } from 'Workspace/TelemetryEvents/search/createSearchCASReporter';

export type Props = RouteComponentProps & WithModalsProps;

function _ItemSearchBar(props: Props) {
	const match = useRouteMatch(searchRoute.paths[0]);
	const searchParams: { search?: string; searchFilterOption?: string } =
		match?.params || {};
	const searchTerm = searchParams.search
		? decodeURIComponent(searchParams.search)
		: t('javascript:search.search_workspace');
	const resources = useLoadableResourceContext();
	const { isLargeFormFactor } = useFormFactor();

	function search() {
		trackAnalyticsEvent(searchCASReporter.getSearchInitEvent());
		props.showModal(<MobileSearchModal />);
	}

	return isSimpleView(resources?.value?.resources) ? null : isLargeFormFactor ? (
		<SearchModule />
	) : (
		<StyledDaasSearchBarDiv
			onClick={search}
			data-testid="search-bar"
			aria-label={t('javascript:search.search_workspace')}
			data-analytics-id="mobile-masthead-search-button"
		>
			<StyledSearchIconContainer>
				<SearchIcon size={18} />
			</StyledSearchIconContainer>
			<StyledSearchTextContainer>
				<StyledDaasSearchTextSpan>{searchTerm}</StyledDaasSearchTextSpan>
			</StyledSearchTextContainer>
		</StyledDaasSearchBarDiv>
	);
}

export const ItemSearchBar = withRouter(withModals(_ItemSearchBar));
